/**
 * Protocolo entre o editor (painel Captação) e a landing dentro do iframe.
 *
 * Era de mão única — o painel empurrava a config e o iframe só desenhava. Com a
 * edição visual ele virou de mão dupla: o iframe devolve seleção, texto editado
 * e reordenação de blocos.
 *
 * Vive num módulo próprio de propósito: o editor precisa só destas constantes, e
 * importá-las de LandingCaptacao arrastaria o renderizador inteiro e os 14
 * blocos para dentro do bundle do CRM.
 */

/** painel → iframe: config em edição. */
export const PREVIEW_MESSAGE = 'landing-captacao:config'

/** iframe → painel: montei, pode mandar. */
export const PREVIEW_PRONTO = 'landing-captacao:ready'

/** iframe → painel: clicaram num campo. */
export const PREVIEW_SELECIONAR = 'landing-captacao:select'

/** iframe → painel: texto alterado direto na página. */
export const PREVIEW_EDITAR = 'landing-captacao:edit'

/** iframe → painel: blocos reordenados por arraste. */
export const PREVIEW_REORDENAR = 'landing-captacao:reorder'

/** painel → iframe: destaque este campo (clique veio da coluna lateral). */
export const PREVIEW_FOCAR = 'landing-captacao:focus'

/** Retângulo do elemento, em coordenadas da viewport do iframe. */
export interface Rect {
  top: number
  left: number
  width: number
  height: number
}

export interface MsgSelecionar {
  type: typeof PREVIEW_SELECIONAR
  bloco: string
  /** undefined quando o clique foi no bloco, não num campo. */
  campo?: string
  /** Índice do item, quando o campo é uma lista. */
  indice?: number
  /** Chave dentro do item, quando o campo é uma lista. */
  subcampo?: string
  rect: Rect
}

export interface MsgEditar {
  type: typeof PREVIEW_EDITAR
  bloco: string
  campo: string
  indice?: number
  /** Chave dentro do item, quando o campo é uma lista. */
  subcampo?: string
  valor: string
}

export interface MsgReordenar {
  type: typeof PREVIEW_REORDENAR
  order: string[]
}

/** Identidade de um campo editável, serializada no atributo data-lp-campo. */
export function chaveCampo(bloco: string, campo: string, indice?: number, subcampo?: string) {
  return [bloco, campo, indice ?? '', subcampo ?? ''].join('|')
}

export function lerChave(v: string) {
  const [bloco, campo, indice, subcampo] = v.split('|')
  return {
    bloco,
    campo,
    indice: indice === '' ? undefined : Number(indice),
    subcampo: subcampo === '' ? undefined : subcampo,
  }
}

/**
 * Campo reservado: a IMAGEM DE FUNDO da lâmina inteira.
 *
 * Não é um campo de conteúdo do blueprint — o fundo mora no ESTILO do bloco. O
 * nome existe para ele entrar no mesmo caminho que já move todo clique do
 * canvas (`chaveCampo` → `data-lp-campo` → `ponte.selecionar` → barra
 * flutuante), em vez de ganhar uma segunda máquina paralela só para si.
 *
 * O `@` na frente é a garantia de que ele nunca colide com uma chave de
 * `BLOCKS`: nenhum `key` de campo começa com símbolo, e um que começasse não
 * seria prop válida do Puck.
 */
export const CAMPO_FUNDO = '@fundo'
